import React from 'react';
import ChatMessageContent from './ChatMessageContent';
import { renderMentionTextNodes } from '../mentions/chatMentionUtils';

export function renderEventImageMessageContent({
  hasImageSource,
  imageSource,
  imageWidth = null,
  imageHeight = null,
  onOpenImage,
  onDownloadImage,
  imageId,
  fullImageSource,
  imageExpiresAt,
  formatExpireDateLabel,
  imageUnavailableText = '画像の保存期間が終了しました。',
}) {
  return (
    <ChatMessageContent
      format="image"
      imageSrc={hasImageSource ? imageSource : ''}
      imageAlt="メッセージ画像"
      imageWidth={imageWidth}
      imageHeight={imageHeight}
      onImageClick={hasImageSource ? onOpenImage : null}
      onImageDownload={
        hasImageSource ? () => onDownloadImage?.('image', imageId, fullImageSource) : null
      }
      imageMeta={
        imageExpiresAt ? `保存期間：${formatExpireDateLabel?.(imageExpiresAt)}まで` : ''
      }
      imageUnavailableText={imageUnavailableText}
    />
  );
}

export function renderEventFileMessageContent({
  canDownload,
  iconClass,
  visualKind,
  displayName,
  fileExpiresAt,
  onDownloadFile,
  fileId,
  fileUrl,
  formatExpireDateLabel,
  fileDisabledText = 'ファイルの保存期間が終わりました。',
}) {
  return (
    <ChatMessageContent
      format="file"
      fileVariant="rich"
      fileName={displayName}
      fileCanDownload={canDownload}
      onFileAction={canDownload ? () => onDownloadFile?.('file', fileId, fileUrl) : null}
      fileIconClass={iconClass}
      fileVisualKind={visualKind}
      fileMeta={fileExpiresAt ? `保存期間：${formatExpireDateLabel?.(fileExpiresAt)}まで` : ''}
      fileDisabledText={fileDisabledText}
    />
  );
}

export function renderEventUnsupportedSystemCard(renderAnnouncementCard, message) {
  const format = String(message?.message_format || '').trim() || 'unknown';
  const content = [
    `message_format: ${format}`,
    String(message?.content || '').trim() || 'このメッセージ形式には対応していません。',
  ].join('\n');
  return renderAnnouncementCard(message, null, {
    title: '未対応のメッセージ',
    content,
  });
}

export function renderEventSystemNoticeCard(renderAnnouncementCard, message) {
  return renderAnnouncementCard(message, null, { title: 'システム通知' });
}

export function renderEventTextMessageContent(linkifyText, content, mentions = [], onMentionClick = null) {
  return (
    <div className="text-message">
      {renderMentionTextNodes({ text: content, mentions, linkifyText, onMentionClick })}
    </div>
  );
}
